import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/management/trash.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-9c3569c2")

_pushScopeId("data-v-9c3569c2")
const _hoisted_1 = { class: "fixedViewOverLayout hasHeader hasFooter genericPadding" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_5 = { class: "amountNumber d-flex align-items-center justify-content-end" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "fs_16 spaceCadet" }, "-", -1)
const _hoisted_7 = { class: "fs_20 fw_700 spaceCadet mx-3" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "fs_16 spaceCadet" }, "+", -1)
const _hoisted_9 = { class: "form-group squareInputContainer withLabel mt-5" }
const _hoisted_10 = { class: "footerButtonContainer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
      }, [
        _hoisted_3
      ]),
      _createVNode(_component_localized_text, {
        class: "fs_13 greyBlue",
        localizedKey: "app_gestiscicarrello",
        text: "Gestisci carrello"
      }),
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearCart()))
      }, [
        _hoisted_4
      ])
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.model.cartItems, (cartItem, index) => {
      return (_openBlock(), _createBlock("div", {
        class: "d-flex align-items-center justify-content-between mb-3",
        key: index
      }, [
        _createTextVNode(_toDisplayString(cartItem.title) + " ", 1),
        _createVNode("div", _hoisted_5, [
          _createVNode("button", {
            onClick: ($event: any) => (_ctx.minusAmount(cartItem))
          }, [
            _hoisted_6
          ], 8, ["onClick"]),
          _createVNode("span", _hoisted_7, _toDisplayString(cartItem.amount), 1),
          _createVNode("button", {
            onClick: ($event: any) => (cartItem.amount++)
          }, [
            _hoisted_8
          ], 8, ["onClick"])
        ])
      ]))
    }), 128)),
    _createVNode("div", _hoisted_9, [
      _createVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_aggiungiDelleNote",
          text: "Aggiungi delle note",
          class: "fs_12 grey"
        })
      ]),
      _withDirectives(_createVNode("textarea", {
        class: "genericInput squareInput ptInput",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.model.notes = $event))
      }, null, 512), [
        [_vModelText, _ctx.model.notes]
      ])
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode("button", {
        type: "button",
        class: "genericButton bgGreyBlue w-100",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.save()))
      }, [
        _createVNode(_component_localized_text, {
          class: "fs_13 white",
          localizedKey: "app_salvamodifiche",
          text: "Salva modifiche"
        })
      ])
    ])
  ]))
})